import axiosClient from "../axiosClient";
import { CheckNullParams } from "../../utils/CheckNullParams";
const categoryApi = {
  getCategories: (params) => {
    const url = "product-category";
    const payload = CheckNullParams(params);
    return axiosClient.get(url, {
      params: payload,
    });
  },
  createCategory: (params) => {
    const url = "product-category";
    const payload = CheckNullParams(params);

    return axiosClient.post(url, payload);
  },
  updateCategory: (id, params) => {
    const url = "product-category/";
    const payload = CheckNullParams(params);
    return axiosClient.patch(url + id, payload);
  },
  deleteCategory: (id) => {
    const url = "product-category/";
    return axiosClient.delete(url + id);
  },
  deleteCategorys: (params) => {
    const url = "product-category";
    console.log("params", params);
    return axiosClient.delete(url, { params });
  },
};

export default categoryApi;
